import { render, staticRenderFns } from "./WillVerification.vue?vue&type=template&id=4161d866&scoped=true"
import script from "./WillVerification.vue?vue&type=script&lang=js"
export * from "./WillVerification.vue?vue&type=script&lang=js"
import style0 from "./WillVerification.vue?vue&type=style&index=0&id=4161d866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161d866",
  null
  
)

export default component.exports